import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollTo } from "./Reveal";
import { PHONES } from "@/data";

const LINKS = [
  ["servicos", "Serviços"],
  ["galeria", "Galeria"],
  ["opinioes", "Opiniões"],
  ["contacto", "Contacto"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-[#0a0a0b]/75 backdrop-blur-xl border-white/10" : "border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button data-testid="nav-logo" onClick={() => scrollTo("topo")} className="flex items-center gap-3">
          <span className="font-serif italic text-3xl gold-text leading-none">RS</span>
          <span className="hidden sm:block text-[11px] tracking-[0.3em] uppercase text-zinc-300">Beauty Salon</span>
        </button>
        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollTo(id)}
              className="group relative text-sm text-zinc-300 hover:text-white transition-colors"
            >
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#d4af37] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <a
          data-testid="nav-whatsapp-cta"
          href={PHONES[0].wa}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border border-[#d4af37]/60 px-5 py-2 text-xs tracking-[0.2em] uppercase text-[#f3e5ab] transition-colors hover:bg-[#d4af37] hover:text-black"
        >
          Marcar
        </a>
      </div>
    </motion.header>
  );
};
